var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62305 8.38477V9.42047H4.69143V8.38477H2.62305ZM17.1229 8.38477V9.42047H20.2311V8.38477H17.1229ZM2.62305 11.4849V12.5205H4.69143V11.4849H2.62305ZM17.1229 11.4849V12.5205H20.2311V11.4849H17.1229ZM2.62305 14.6V15.6358H4.69143V14.6H2.62305ZM17.1229 14.6V15.6358H20.2311V14.6H17.1229ZM2.62305 17.7163V18.752H4.69143V17.7163H2.62305ZM17.1229 17.7163V18.752H20.2311V17.7163H17.1229Z",
    fill: "#0C66E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84375 8.38477V9.42047H12.9795V8.38477H8.84375ZM8.84375 11.4849V12.5205H12.9795V11.4849H8.84375ZM8.84375 14.6V15.6358H12.9795V14.6H8.84375ZM8.95803 17.7163V18.752H12.9036V17.7163H8.95803Z",
    fill: "#0C66E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0429688 0.62915V23.3975H4.69454V21.8419H1.5945V6.22238H4.69454V4.6698H1.5945V2.18167H4.69454V0.62915H0.0429688ZM17.1422 0.62915V2.18167H21.2628V4.6698H17.1422V6.22238H21.2628V21.8419H17.1422V23.3975H22.8144V0.62915H17.1422ZM8.84344 4.76083V6.31641H12.9832V4.76083H8.84344Z",
    fill: "#0C66E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73242 0.104492C5.73242 8.04177 5.73242 15.979 5.73242 23.9163H16.1035V0.104492H5.73242ZM7.80435 2.17642H14.0354V21.8444H7.80435V2.17642Z",
    fill: "#0C66E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.f1057a81cb9f84d15386cec7c2fd88c1.svg";
export { ForwardRef as ReactComponent };